// extracted by mini-css-extract-plugin
module.exports = {"SocialMediaApp":"SocialMediaApp_SocialMediaApp__3nosm","container":"SocialMediaApp_container__3wIBh"};